// const { ScrollSpy } = require("bootstrap");
require("aos/dist/aos.js");
import AOS from 'aos';

$(function () {
    $('.backdrop-nav').hide();
    var currentUrl = '';
    const spyscroll = () => {
        var sTop = $(window).scrollTop();
        $(".chapter").each(function () {
            var id = $(this).attr("id"),
                offset = $(this).offset().top - 1,
                height = $(this).height();
            if (sTop >= offset && sTop < offset + height) {
                // console.log();
                const chapterTitle = $(this).data('title');
                $('header .chapter-title').text(chapterTitle);
                
                if(id !== currentUrl) {
                    history.pushState(null, null, `#${id}`);
                    currentUrl = id;
                }

                $('.link-to-chapter').removeClass('active');
                $('.link-to-chapter[href="#' + id + '"]').addClass('active');
                // link.removeClass("active");
                // $("#navbar")
                //     .find('[data-scroll="' + id + '"]')
                //     .addClass("active");
            }
        });
    }

    $(window).on("scroll", spyscroll);
    // $(window).on("load", function() {
    //     $('.preloader').hide();
    //     $('body').removeClass('overflow-hidden');
    //     const homeVideo = document.getElementById('home-video');
    //     if(homeVideo !== null) {
    //         homeVideo.play();
    //     }
    // });

    const firstInit = () => {
        let idVideo;
        
        if($(window).width() > 768) {
            idVideo = 'home-video';
        } else {
            idVideo = 'home-video-mobile';
        }

        const homeVideo = document.getElementById(idVideo);
        if(homeVideo !== null) {
            // console.log(homeVideo);
            var b = setInterval(()=>{
                console.log(homeVideo.readyState);
                if(homeVideo.readyState >= 3){
                    $('.preloader').hide();
                    $('body').removeClass('overflow-hidden');
                    homeVideo.play();
                    AOS.init({
                        offset: 200, // offset (in px) from the original trigger point
                        once: true, // whether animation should happen only once - while scrolling down
                        duration: 400, // values from 0 to 3000, with step 50ms
                    });
                    clearInterval(b);
                }                   
            }, 100);
            // homeVideo.addEventListener("loadeddata", function() {
            //     $('.preloader').hide();
            //     $('body').removeClass('overflow-hidden');
            //     homeVideo.play();
            // });
        } else {
            setTimeout(() => {
                $('.preloader').hide();
                $('body').removeClass('overflow-hidden');
                AOS.init({
                    offset: 200, // offset (in px) from the original trigger point
                    once: true, // whether animation should happen only once - while scrolling down
                    duration: 400, // values from 0 to 3000, with step 50ms
                });
            }, 3000);
        }
    }

    firstInit();
    
    spyscroll();


    let lastScrollTop = 0;
    let onResize = false;
    // $(window).on("resize", function (event) {
    //     onResize = true;
    // });

    $(window).on("scroll", function (event) {
        // console.log(onResize);
        if(!onResize) {
            let st = $(this).scrollTop();
    
            if (st > ($("#great-food-puzzle").height() - 500)) {
                if (st <= lastScrollTop) {
                    $("header").addClass("fixed");
                    $("header").addClass("scrolling");
                }
            } else {
                $("header").removeClass("fixed");
                $("header").removeClass("scrolling");
            }
    
            if (st > ($("#great-food-puzzle").height() - 500)) {
                if (st > lastScrollTop) {
                    $("header").addClass("scroll-down");
                    $("header").removeClass("scroll-up");
                } else {
                    $("header").removeClass("scroll-down");
                    $("header").addClass("scroll-up");
                }
            } else {
                $("header").removeClass("scroll-up");
                $("header").removeClass("scroll-down");
            }
            lastScrollTop = st;
        } else {
            onResize = false;
        }
    });        

    // nav
    $('body').on('click', '.open-nav', function (e) {
        e.preventDefault();
        onResize = true;
        $('body').addClass('overflow-hidden');
        $('.main-nav').addClass('active');
        $('header').addClass('scroll-up');
        $('header').removeClass('scroll-down');
        $('.backdrop-nav').show();
    });



    $('body').on('click', '.close-nav, .backdrop-nav', function (e) {
        e.preventDefault();
        $('body').removeClass('overflow-hidden');
        $('.main-nav').removeClass('active');
        $('.backdrop-nav').hide();
    });

    $('body').on('click', '.link-to-chapter', function (e) {
        $('body').removeClass('overflow-hidden');
        $('.main-nav').removeClass('active');
    });

    function updateShareLink() {
        const placeholderText = $('meta[name=share-placeholder-text]').prop('content');
        // const placeholderText = 'Check+out+WWF%27s+new+report+-+it%27s+helping+us+figure+out+how+to+nourish+everyone+in+the+world+without+harming+the+planet%21+%0D%0A%0D%0AThe+%23GreatFoodPuzzle%F0%9F%A7%A9+is+a+global+problem+that+requires+local+action.+The+report+explores+priority+actions+for+different+countries%0D%0A%0D%0A';
        const urlText = $('meta[property="twitter:url"]').prop('content');
        $('#share-button-container a').each(function () {
            let linkTemplate = '';
            if ($(this).hasClass('fb')) {
                linkTemplate = 'https://www.facebook.com/sharer/sharer.php?u=';
            } else if ($(this).hasClass('tw')) {
                linkTemplate = 'https://twitter.com/intent/tweet?text=' + placeholderText + '&url=';
            } else if ($(this).hasClass('ln')) {
                linkTemplate = 'https://www.linkedin.com/sharing/share-offsite/?url=';
            }
            $(this).attr('href', linkTemplate + '' + encodeURIComponent(urlText));
        })
    }

    updateShareLink();
});
